export default __webpack_public_path__ + "static/media/modelX.c660f735.png";